import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { useThree } from '@react-three/fiber';
import { Vector3 } from 'features/morphing/state/parameterAtoms';
import { maxDesignSpaceState, minDesignSpaceState } from 'features/optimization/state/appConfigAtoms';
import { createCoordinates, isDrawable } from '../utils/utils';

export const useDesignSpaceViewerData = () => {
  const controlPoints: Vector3 = { x: 2, y: 2, z: 2 };
  const minDesignSpace = useRecoilValue(minDesignSpaceState);
  const maxDesignSpace = useRecoilValue(maxDesignSpaceState);
  const { scene } = useThree();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const drawable = useMemo(() => isDrawable(controlPoints, minDesignSpace, maxDesignSpace), [minDesignSpace, maxDesignSpace]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const coordinates = useMemo(() => drawable ? createCoordinates(controlPoints, minDesignSpace, maxDesignSpace) : [], [drawable, minDesignSpace, maxDesignSpace]);

  return { scene, drawable, coordinates };
};
